import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import { useShopSEO } from '../lib/seo';
import { STORE } from '../lib/i18n';
import { waLink } from '../lib/whatsapp';
import ApplyWithAffirm from '../components/ApplyWithAffirm';
import CategoryPrice from '../components/CategoryPrice';

const CATEGORIES = [
  { slug: 'refrigerators',  img: '/img/cat-refrigerators.jpg',  key: 'refrigerators' },
  { slug: 'stoves',         img: '/img/cat-stoves.jpg',         key: 'stoves' },
  { slug: 'washers-dryers', img: '/img/cat-washers-dryers.jpg', key: 'washers-dryers' },
  { slug: 'microwaves',     img: '/img/cat-microwaves.jpg',     key: 'microwaves' },
];

const buildCategoryWa = ({ catName, lang }) => {
  const greet = lang === 'es' ? 'Hola Nathanael Appliances Corp' : 'Hi Nathanael Appliances Corp';
  const ask = lang === 'es'
    ? `Me interesan los modelos y precios actuales de ${catName}.`
    : `I'd like to ask about current models and prices for ${catName}.`;
  return [greet + ',', '', ask].join('\n');
};

export default function Shop() {
  const { lang, t } = useLang();
  useShopSEO({ lang });

  return (
    <div className="shop-page">
      <div className="wrap">
        <div className="shop-head">
          <span className="section-kicker">{t('nav.shop')}</span>
          <h1 className="shop-h1">
            {t('shop.title.a')}<em>{t('shop.title.em')}</em>{t('shop.title.b')}
          </h1>
          <p className="section-sub">{t('shop.sub')}</p>
          <div className="shop-head-cta">
            <ApplyWithAffirm price={500} size="md" />
          </div>
        </div>

        <div className="cat-grid" data-testid="shop-category-grid">
          {CATEGORIES.map(c => {
            const catName = t(`cat.${c.key}`);
            const waText = buildCategoryWa({ catName, lang });
            return (
              <div key={c.slug} className="cat-card static" data-testid={`shop-cat-${c.slug}`}>
                <div className="cat-img">
                  <img src={c.img} alt={catName} loading="lazy" />
                </div>
                <div className="cat-body">
                  <h3>{catName}</h3>
                  <CategoryPrice slug={c.slug} />
                  {c.slug !== 'microwaves' && <p>{t('shop.askModels')}</p>}
                  <div className="cat-actions">
                    <a
                      href={`tel:${STORE.phoneRaw}`}
                      className="btn btn-primary btn-sm"
                      data-testid={`cat-call-${c.slug}`}
                    >
                      <i className="fa-solid fa-phone"></i>
                      <span>{t('shop.callUs')}</span>
                    </a>
                    <a
                      href={waLink(waText)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-wa btn-sm"
                      data-testid={`cat-wa-${c.slug}`}
                    >
                      <i className="fa-brands fa-whatsapp"></i>
                      <span>{t('shop.waUs')}</span>
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
